(ns practitest.frontend.forms3.instance.version-selector
  (:require
    [day8.re-frame.http-fx]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.i18n :refer [get-translation] :as i18n]
    [practitest.frontend.common.re-frame :refer [partial-dispatch
                                                 partial-dispatch-sync
                                                 partial-subscribe]]
    [practitest.frontend.components.grid.localstorage :as grid-storage]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.forms3.entity-form.fields :as fields3]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

;; Slightly abusing internals of forms implementation - reusing existing form-id
;; so dirty fields handling and all relevant stuff is handled by entity form code
(def form-id :instance-main)

(defn get-field-config
  [base-entity field-id]
  (let [test (:qtest_design base-entity)
        ;; Only show values that are used in previous versions
        possible-values (filter :used_in_old_versions (:relevant_version_labels test))]
    {:label (get-translation "instance.version-selector.test-version" "Test Version")
     :field field-id
     :field-id field-id
     :field-name field-id
     :name field-id
     :mandatory? true
     :type :version_label
     :possible-values possible-values
     :edit-permissions? true}))

(re-frame/reg-sub
  ::version-field-props
  :<- [::forms/base-entity :instance]
  (fn [base-entity [_ field-id]]
    (get-field-config base-entity field-id)))

(defn reset-form-state
  [db instance]
  (-> db
      (assoc-in [:form-states2 form-id :fields :version_label :value]
                (:version_label instance))))

(def version-selector-form-props
  {:get-field-props (partial-subscribe [::version-field-props])
   :get-form-state (partial-subscribe [::forms/form-state form-id])
   :set-form-state (partial-dispatch [::forms/set-form-state form-id])

   :get-field-state (partial-subscribe [::forms/field-state form-id])
   :set-field-state (partial-dispatch-sync [::forms/set-field-state form-id])

   :form-ref (atom nil)})

(defn instance-version-section [form-props]
  (reagent/with-let [collapsed? (reagent/atom
                                  (grid-storage/get-section-collapsed :instance "instance-version" true))]
    (let [{:keys [base-entity new? edit-permissions?]} form-props]
      [:div.side-panel-section
       [:div.fields-panel
        {:class (dom/classes-pairs-v :section-collapsed @collapsed?)}
        [:div.header
         {:class (dom/classes-pairs-v :collapsed @collapsed?)}
         [buttons/icon-button
          {:icon (if @collapsed?
                   [icons/mux-chevron-right]
                   [icons/mux-chevron-down2])
           :on-click #(let [new-state (not @collapsed?)]
                        (reset! collapsed? new-state)
                        (grid-storage/set-section-collapsed :instance "instance-version" new-state))}]
         [:div.title (get-translation "instance.version-selector.title"
                                      "Select a Version Label")]]
        (when-not @collapsed?
          [:div
           [fields3/build-field
            {:field-name :version_label
             :edit-permissions? edit-permissions?}
            version-selector-form-props]])]])))
